export default __webpack_public_path__ + "static/media/kuvantaminen-white.2461a2d3.svg";